import { getLocalDateObject } from "../dateTimeZone";
// Devuelve el lunes de la semana (semana = lunes-domingo)
function getStartDateOfWeek(week, year) {
    const first = new Date(year, 0, 1);
    const day = first.getDay() || 7; // domingo = 7
    const firstMonday = new Date(first);
    firstMonday.setDate(first.getDate() - day + 1); // primer lunes del año

    const monday = new Date(firstMonday);
    monday.setDate(firstMonday.getDate() + (week - 1) * 7);
    monday.setHours(0, 0, 0, 0);

    return monday;
}
export function getPresentialPaymentType(targetWeek, targetYear, classDaysStr) {
    const daysOrder = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

    // Convertir lista de días
    let classDays = [];
    if (!classDaysStr) classDays = ["Lunes"];
    else classDays = classDaysStr.split(",").map(d => d.trim()).filter(Boolean);

    const dayIndexes = classDays.map(d => daysOrder.indexOf(d)).filter(i => i >= 0);
    if (dayIndexes.length === 0) dayIndexes.push(0);

    const now = getLocalDateObject();
    const monday = getStartDateOfWeek(targetWeek, targetYear);

    // Semana siguiente → late
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    sunday.setHours(23, 59, 59, 999);

    if (now > sunday) return "late";

    const minDay = Math.min(...dayIndexes);
    const maxDay = Math.max(...dayIndexes);

    // A) Solo DOMINGO
    if (dayIndexes.length === 1 && dayIndexes[0] === 6) {
        if (now <= sunday) return "prompt";
        return "late";
    }

    // B) Solo jueves-viernes-sábado (1 o 2 días)
    const isThuFriSatOnly = dayIndexes.every(i => i >= 3 && i <= 5);
    if (isThuFriSatOnly) {
        const lastClassDay = new Date(monday);
        lastClassDay.setDate(monday.getDate() + maxDay);
        lastClassDay.setHours(23, 59, 59, 999);

        if (now <= lastClassDay) return "prompt";
        if (now <= sunday) return "normal";
        return "late";
    }

    // C) Solo lunes-martes-miércoles
    const isMonTueWedOnly = dayIndexes.every(i => i >= 0 && i <= 2);
    if (isMonTueWedOnly) {
        const wednesday = new Date(monday);
        wednesday.setDate(monday.getDate() + 2);
        wednesday.setHours(23, 59, 59, 999);

        if (now <= wednesday) return "prompt";
        if (now <= sunday) return "normal";
        return "late";
    }

    // D) Grupo normal → Prompt SOLO hasta miércoles
    const wednesday = new Date(monday);
    wednesday.setDate(monday.getDate() + 2);
    wednesday.setHours(23, 59, 59, 999);

    if (now <= wednesday) return "prompt";
    if (now <= sunday) return "normal";
    return "late";
}

export const toComparable = (weekKey) => {
    const [week, year] = weekKey.split("-").map(Number);
    return year * 100 + week;
};

export const isWeekInRanges = (weekKey, ranges) => {
    const value = toComparable(weekKey);

    return ranges.some(range => {
        const start = toComparable(range.start);
        const end = toComparable(range.end);
        return value >= start && value <= end;
    });
};